import React, {useState} from 'react';

import {SequenceTopology} from 'constants/SequenceConstants';
import {ButtonSize} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import ToggleGroup from 'ui-library/ToggleGroup';

interface SelectTopologyModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (topology: SequenceTopology) => void;
}

export default function SelectTopologyModal({
  onRequestClose,
  onRequestSubmit,
}: SelectTopologyModalProps): JSX.Element {
  const [topology, setTopology] = useState(SequenceTopology.CIRCULAR);
  return (
    <Modal
      buttons={[{text: 'Submit', submit: true}]}
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        onRequestSubmit(topology);
      }}
      title="Set Topology"
    >
      <ToggleGroup<SequenceTopology>
        selection={topology}
        size={ButtonSize.MEDIUM}
        onChangeSelection={setTopology}
        options={[
          {id: SequenceTopology.CIRCULAR, buttonProps: {text: 'Circular'}},
          {id: SequenceTopology.LINEAR, buttonProps: {text: 'Linear'}},
        ]}
      />
    </Modal>
  );
}
